import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { SwiperSlide, Swiper } from 'swiper/react';
import "swiper/css";
import "../category-list/categoryList.scss";
import AreaCard from '../area-card/AreaCard';
import "../category-grid/categoryGrid.scss";
import { useLocation } from 'react-router-dom';

const Alphabets = () => {
    const alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', "R", 'S', 'T', 'V', 'W', 'Y'];
    const location = useLocation().pathname;
    return (
        <>
            {
                location !== '/alphabets' ? (
                    <div className="category-list">
                        <Swiper
                            grabCursor={true}
                            spaceBetween={10}
                            slidesPerView={'auto'}

                        >
                            {
                                alphabets.slice(0, 9).map((alphabet, index) => (
                                    <SwiperSlide key={index}>
                                        {/* <p>{alphabet}</p> */}
                                        <AlphabetList alphabet={alphabet} />
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                    </div>
                ) : (
                    <>
                        {
                            alphabets.map((alphabet, index) => (
                                <AlphabetList alphabet={alphabet} key={index} />
                            ))
                        }
                    </>
                )
            }
        </>
    )
}

const AlphabetList = props => {
    const [aFoods, setAFoods] = useState([]);
    useEffect(() => {
        const getAreas = async () => {
            const response = await axios.get(`https://www.themealdb.com/api/json/v1/1/search.php?f=${props.alphabet}`);
            setAFoods(response.data.meals[0]);
            // console.log(response.data.meals[0]);
        }
        getAreas();
    }, [props.alphabet]);
    return (
        <AreaCard area={props.alphabet} image={aFoods.strMealThumb} />
    )
}

export default Alphabets